const FEATURES = [
  {
    no: "01",
    kicker: "现场直击",
    title: "红毯风波深夜升级：主办方紧急回应，风向一夜反转",
    excerpt:
      "事件查询热度持续走高，站内查找同一关键词的讨论在一小时内新增上万条。主办方两版口径被网友逐条对比，评论区站队与追问交织，事态仍在快速发酵。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20crowd%20of%20paparazzi%20with%20camera%20flashes%20in%20front%20of%20a%20red%20carpet%20at%20night%2C%20blurred%20bokeh%20lights%2C%20warm%20crimson%20and%20gold%20tone%2C%20cinematic%20film%20grain%2C%20high%20contrast%2C%20tension%20and%20urgency%2C%20magazine%20news%20photography%20aesthetic&width=1200&height=760&seq=event-redcarpet-01&orientation=landscape",
    tag: "引爆",
    time: "06 小时前",
    views: "312 万浏览",
    replies: "2.1 万评论",
  },
  {
    no: "02",
    kicker: "深挖还原",
    title: "录音门背后：三段音频拼出的时间线，网友逐帧扒出细节",
    excerpt:
      "人物专题与事件查询联动，把被扒出的一句句对白放进时间轴，真相仍在争议中。站内查找显示，该事件的完整梳理已被收藏超过 40 万次，成为本周最完整的吃瓜存档。",
    image:
      "https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20studio%20microphone%20and%20audio%20waveform%20on%20dark%20background%2C%20single%20warm%20amber%20spotlight%2C%20deep%20shadow%2C%20mystery%20and%20intrigue%2C%20cinematic%20film%20grain%2C%20editorial%20investigation%20storytelling%20mood&width=1200&height=760&seq=event-recording-02&orientation=landscape",
    tag: "深挖",
    time: "1 天前",
    views: "588 万浏览",
    replies: "3.6 万评论",
  },
];

const TRACKS = [
  { no: "A-0917", name: "直播翻车事件", status: "已归档", tone: "text-stone-500 border-stone-200", heat: "热度回落" },
  { no: "B-2406", name: "新剧撕番之争", status: "持续中", tone: "text-red-700 border-red-200 bg-red-700/5", heat: "飙升中" },
  { no: "C-3351", name: "机场偶遇风波", status: "热议中", tone: "text-amber-700 border-amber-200 bg-amber-700/5", heat: "评论+48%" },
];

export default function EventsSection() {
  return (
    <section id="events" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      {/* header */}
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold text-red-700">
            <span className="h-px w-8 bg-red-700"></span>
            事件查询 · 现场档案
          </div>
          <h2 className="font-serif-sc mt-3 text-balance text-2xl font-black text-stone-900 md:text-3xl">
            正在发酵的瓜，都在这里被扒透
          </h2>
        </div>
        <a href="#search" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-stone-500 hover:text-red-700">
          去站内查找更多事件
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>

      {/* big feature cards */}
      <div className="mt-8 flex flex-col gap-6">
        {FEATURES.map((f) => (
          <article key={f.no} className="paper-card grid grid-cols-1 overflow-hidden rounded-lg lg:grid-cols-12">
            <div className="relative lg:col-span-7">
              <img
                src={f.image}
                alt={`${f.title} 网曝网事件查询封面`}
                title={`${f.title} 网曝网事件查询`}
                className="h-64 w-full object-cover object-top md:h-96 lg:h-full"
              />
              <span className="absolute left-4 top-4 rounded-sm bg-red-700 px-2.5 py-1 text-xs font-bold text-[#f7f3eb]">
                {f.tag}
              </span>
            </div>
            <div className="flex flex-col justify-center p-6 md:p-10 lg:col-span-5">
              <div className="flex items-center gap-2 text-xs text-stone-400">
                <span className="font-serif-sc font-black text-red-700">{f.no}</span>
                <span className="h-1 w-1 rounded-full bg-stone-300"></span>
                <span>{f.kicker}</span>
                <span className="h-1 w-1 rounded-full bg-stone-300"></span>
                <span>{f.time}</span>
              </div>
              <h3 className="font-serif-sc mt-3 text-xl font-bold leading-snug text-stone-900 md:text-2xl">
                {f.title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-stone-600">{f.excerpt}</p>
              <div className="magazine-rule mt-5 h-px w-full"></div>
              <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-stone-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line w-4 h-4 flex items-center justify-center"></i>
                  {f.views}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center"></i>
                  {f.replies}
                </span>
                <a href="#hot" className="ml-auto inline-flex items-center gap-1 whitespace-nowrap font-semibold text-red-700 hover:text-red-800">
                  进入评论区吃瓜
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* dense tracking list */}
      <div className="paper-card mt-6 rounded-lg p-5 md:p-6">
        <div className="flex items-center justify-between">
          <h4 className="flex items-center gap-2 text-sm font-bold text-stone-800">
            <i className="ri-history-line w-4 h-4 flex items-center justify-center text-red-700"></i>
            事件脉络 · 站内追踪中
          </h4>
          <span className="text-xs text-stone-400">实时归档于网曝网关键词库</span>
        </div>
        <div className="mt-4 divide-y divide-stone-100">
          {TRACKS.map((t) => (
            <div key={t.no} className="flex items-center gap-3 py-3 text-sm">
              <span className="w-16 shrink-0 font-mono text-xs text-stone-400">{t.no}</span>
              <span className="flex-1 font-medium text-stone-800">{t.name}</span>
              <span className={`hidden items-center rounded-full border px-2.5 py-0.5 text-xs sm:inline-flex ${t.tone}`}>
                {t.status}
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-red-700">
                <i className="ri-fire-fill w-4 h-4 flex items-center justify-center"></i>
                {t.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}